// extracted by mini-css-extract-plugin
export default {"modal":"modal--Lphia","body":"body--rw79R","content":"content--DfpAf","modalFooter":"modalFooter--Da1uF","disabled":"disabled--VWflv","warning":"warning--fpCWX"};